<span class="td-wb-icon-arrow__wrap">
    <td-wb-icon [iconId]="iconId()"
                [size]="iconSize()" />
</span>
